export function formatDateFromString(date) {
  const newDate = new Date(date);
  const localeDate = newDate.toLocaleDateString();
  return localeDate;
}
